// import {Loader, LoaderOptions} from 'google-maps';
import { Loader, LoaderOptions } from 'google-maps'
// import { Loader, Loader } from

//DON'T UPDATE PACKAGE UNTIL IE11 IS BLOODY DISCONTINUED NEXT YEAR!
import loadGoogleMapsApi from 'load-google-maps-api';
import Swiper, { EffectFade, Pagination, Navigation } from 'swiper';

export default class {
    /**
     * Map that shows location of embankment and key hill
     * and there distancies to local amenities.
     */
    constructor(el) {
        this.map_el = document.querySelector(el);
		this.loaded = false;
        if(this.map_el) {
            /**
             * The data from the ACF blocks (JSON).
             */
            this.data = JSON.parse(this.map_el.getAttribute('data-markers'));

			/**
             * Locations to display
             */
			this.locations = this.data.locations;

			//calculating the average lat and lng to set for the map
			let average_lat = 0; let average_lng = 0;
			this.locations.forEach(marker => {
				average_lat += marker.lat;
				average_lng += marker.lng;
			})

			if(average_lat !== 0 && average_lng !== 0) {
				this.lat = average_lat / this.locations.length;
				this.lng = average_lng / this.locations.length;

				loadGoogleMapsApi({key: wordpress_globals.google_maps_api_key }).then(mapsApi => {
					this.api = mapsApi;
					this.infowindow = new mapsApi.InfoWindow({
						content: 'dsfdsfdsfs',
						closeBoxURL: ''
					});
					// console.log("Info window: ", this.infowindow);
					if(this.map_el) {
						const offset = 1000;
						window.addEventListener('scroll', () => {
							if (this.loaded === false &&
								window.scrollY > this.map_el.offsetTop - window.innerHeight - offset
							) {
								console.log('loading map');
								this.loaded = true;
								this.initialise_map();
							}
						});
					}
				});

				console.log("Data", this.data);
			}
        }
    }

    initialise_map() {
		let customStyle = [
			{
				featureType: "all",
				elementType: "labels",
				stylers: [
					{ visibility: "off" }
				]
			},
			{
				"featureType": "all",
				"elementType": "labels.icon",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "administrative",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 17
					},
					{
						"weight": 1.2
					}
				]
			},
			{
				"featureType": "landscape",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#35353b"
					},
					{
						"lightness": "-0"
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#212829"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#7d7d7d"
					},
					{
						"weight": "2.86"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 29
					},
					{
						"weight": 0.2
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#6a6a6a"
					},
					{
						"weight": ".5"
					}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#565656"
					},
					{
						"weight": "0.36"
					}
				]
			},
			{
				"featureType": "transit",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#4c988f"
					},
					{
						"lightness": 19
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#1bb7cb"
					},
					{
						"lightness": "-37"
					}
				]
			}
		];

		this.map = new this.api.Map(this.map_el, {
            center: {lat: this.lat, lng: this.lng},
            zoom: 14,
            mapTypeControl: false,
			streetViewControl: false,
			disableDoubleClickZoom: true,
			clickableIcons: false,
			styles: customStyle,
		})

		if(window.innerWidth < 1200) {
			this.map.panBy(0, -60);
		} else {
			this.map.panBy(0, -125);
		}

		this.locations.forEach(marker => {
			this.create_HTML_marker(marker);
		})

		Swiper.use([Pagination, Navigation]);

		setTimeout(() => {
			let swiper = new Swiper('.marker-swiper', {
				direction: 'horizontal',
				loop: true,
				allowTouchMove: false,
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					clickable: true
					// bulletElement: 'span'
				}
			})
		}, 1000);
    }


    create_HTML_marker(marker) {
		let that = this;
		function HTMLMarker(lat, lng) {
			this.lat = lat;
			this.lng = lng;
			this.setMap(that.map);
			this.pos = new google.maps.LatLng(lat,lng);
		}

		HTMLMarker.prototype = new google.maps.OverlayView();
		HTMLMarker.prototype.onRemove= function(){
			if (this.div) {
				this.div.parentNode.removeChild(this.div);
				this.div = null;
				this.setMap(null);
			}
		}

		//init your html element here
		HTMLMarker.prototype.onAdd= function(){
			var div = document.createElement('DIV');
			div.classList.add("marker_element");
			div.style.position='absolute';

			div.innerHTML = `
				<a tabindex="-1" class = "mobile-link" href = "/living/${marker.title.replace(' ', '-')}">
					<div class="mobile-marker">
						<img class="lazyload arrow" src="/wp-content/themes/class/dist/images/icons/bottom-marker.png" alt=""/>
						<img class="lazyload icon" alt="${marker.title}'s icon" src='${marker.icon}'>
						<h4>${marker.title}</h4>
					</div>
				</a>
				<div class="marker_content_holder">
					<div class="marker"></div>
					<a href="/living/${marker.title.replace(' ', '-')}">
						<div class="marker_content ${marker.direction}">
							<img class="arrow" src="${marker.direction === 'right' ? '/wp-content/themes/class/dist/images/icons/Left-marker.png' : '/wp-content/themes/class/dist/images/icons/Right-marker.png' }" alt="" />
							<div class="marker-swiper">
								<div class="swiper-wrapper">
									${ marker.image_html }
								</div>
								<div class="swiper-pagination"></div>
							</div>
							<div class="content">
								<div class="title">
									<img alt="${marker.title}'s icon" src='${marker.icon}'>
									<h4>${marker.title}</h4>
								</div>
								<div class="distance">
									<p>${marker.address}</p>
								</div>
							</div>
						</div>
					</a>
				</div>
			`;

			// ${(!marker.is_available) ? '<span class = "coming-soon">Coming Soon!</span>' : ''}

			var panes = this.getPanes();
			panes.overlayMouseTarget.appendChild(div);

			this.div = div;
		}

		HTMLMarker.prototype.draw = function(){
			var overlayProjection = this.getProjection();
			// this.div.removeAttribute("style");
			var position;
			position = overlayProjection.fromLatLngToDivPixel(this.pos);

			this.div.style.left = position.x + 'px';
			this.div.style.top = position.y + 'px';
			var panes = this.getPanes();
		}


		HTMLMarker.prototype.setPosition = function(position, rating = "All", type = "region") {
			var point;
			if(rating !== "All" && type === "la") {
				// this.latlng_ = position;
				point = this.getProjection().fromLatLngToDivPixel(position);
			} else {
				point = this.getProjection().fromLatLngToDivPixel(this.pos);
			}
			if (point) {
				this.pos = position
			}
        };

		let el;

		el = new HTMLMarker(marker.lat, marker.lng);
		// el.setVisible(visible);
		el.setMap(this.map);

		// this.create_chart(id, data);
		return el;
	}
}
